import React from 'react'
import classNames from 'classnames'
import { AsH2, TitleMD, ParagraphMD } from '@/atoms/Text'
import { useThemeContext } from '@/contexts/ThemeContext'
import { useTranslate } from '@/utils/translate/translate-client'
import { SharingBlock } from './SharingBlock'

export interface ShareSectionProps {
  shareUrl: string
  projectName: string
  theatricalSlug: string
  className?: string
  headerClassName?: string
  projectType?: string
}

export const ShareSection: React.FC<ShareSectionProps> = ({
  shareUrl,
  projectName,
  theatricalSlug,
  className,
  headerClassName,
  projectType = 'movie',
}) => {
  const { t } = useTranslate('common')
  const { isDarkMode } = useThemeContext()
  const projectLabel = projectType === 'movie' ? 'movie' : projectType === 'special' ? 'special' : 'show'
  return (
    <div
      className={classNames(
        'photon-paragraph-md mx-2 text-center font-whitney font-medium flex flex-col justify-center items-center',
        isDarkMode ? 'bg-black' : 'bg-white',
        className,
      )}
    >
      <TitleMD
        id="share-section-title"
        as={AsH2}
        weight="bold"
        className={classNames(
          'py-2',
          {
            'text-white': isDarkMode,
          },
          headerClassName,
        )}
      >
        {t('shareProject', 'Share {{name}}', { name: projectName })}
      </TitleMD>
      <ParagraphMD
        weight="normal"
        color={isDarkMode ? 'core-gray-300' : 'core-gray-700'}
        className="max-w-[600px] text-base"
      >
        {t(
          'togetherWeCanReachWorldShare',
          'Together, we reach every corner of the world. Click below to share this {{ project }} with family & friends and see the impact of your share.',
          { project: projectLabel },
        )}
      </ParagraphMD>
      <div className="pb-6 pt-3">
        <SharingBlock projectSlug={theatricalSlug} shareUrl={shareUrl} />
      </div>
    </div>
  )
}
